import { differenceInCalendarDays, format } from "date-fns";

import type { IHotelsSearchSchema } from "@/feature/hotel/search/types/hotel-search-type";

export function formatDateRange(searchData: IHotelsSearchSchema | null) {
  if (!searchData?.date?.from || !searchData?.date?.to) {
    return "Pick dates";
  }

  return `${format(new Date(searchData.date.from), "MMM d")} - ${format(new Date(searchData.date.to), "MMM d")}`;
}

export function formatGuests(searchData: IHotelsSearchSchema | null) {
  if (!searchData?.rooms?.length) {
    return "1 guest";
  }

  const guests = searchData.rooms.reduce((total, room) => {
    return total + room.adults + room.children + room.infants;
  }, 0);

  return `${guests} guest${guests === 1 ? "" : "s"}`;
}

export function formatRooms(searchData: IHotelsSearchSchema | null) {
  if (!searchData?.rooms?.length) {
    return "1 room";
  }

  const totalRooms = searchData.rooms.length;
  return `${totalRooms} room${totalRooms === 1 ? "" : "s"}`;
}

export function formatNights(searchData: IHotelsSearchSchema | null) {
  if (!searchData?.date?.from || !searchData?.date?.to) {
    return "1 night";
  }

  const nights = differenceInCalendarDays(
    new Date(searchData.date.to),
    new Date(searchData.date.from),
  );
  return `${nights} night${nights === 1 ? "" : "s"}`;
}
